import script from "./ExportFormsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ExportFormsCard.vue?vue&type=script&setup=true&lang=js"

import "./ExportFormsCard.vue?vue&type=style&index=0&id=0dbad9ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0dbad9ea"]])

export default __exports__